<template lang="html">
  <form role="form">
    <template v-if="model.options.kyc_rejected">
      <payout-form-group>
        <div class="form-control-space">
          <payout-hint-panel class="payout-hint-panel-warning" heading="">
            <walleto-kyc-reset-warning-payout-hint></walleto-kyc-reset-warning-payout-hint>
          </payout-hint-panel>
        </div>
      </payout-form-group>
    </template>

    <payout-form-group v-if="isIntercashEuroUSDTopupNotAvailableAlert">
      <div class="form-control-space">
        <payout-hint-panel :warning="true">
          {{ $t('ic_euro_usd_disabled_text') }}
        </payout-hint-panel>
      </div>
    </payout-form-group>

    <template v-if="model.options.ic_not_avail">
      <payout-form-group>
        <div class="form-control-space">
          <payout-hint-panel class="payout-hint-panel-warning" heading="">
            <div>
              <p>{{ model.options.warning_ic_not_avail }}</p>
            </div>
          </payout-hint-panel>
        </div>
      </payout-form-group>
    </template>
    <template v-if="hasWalleto">
      <payout-form-group v-if="!model.options.temp_problems_walleto">
        <div class="form-control-space">
          <payout-hint-panel class="payout-hint-panel-warning" heading="">
            <div>
              <p>{{ $t('cardtopup.walleto_limits_warning') }}</p>
            </div>
          </payout-hint-panel>
        </div>
      </payout-form-group>
      <payout-form-group
        v-if="isSelectedCardIsWalleto && model.options.temp_problems_walleto">
        <div class="form-control-space">
          <payout-hint-panel class="payout-hint-panel-warning" heading="">
            <div>
              <p>{{ $t('cardtopup.walleto_temp_problems') }}</p>
            </div>
          </payout-hint-panel>
        </div>
      </payout-form-group>
    </template>
    <!-- payout-form-group(v-if="isUSD")
    .form-control-space
      payout-hint-panel.payout-hint-panel-warning(heading='')
        div
          p {{$t('cardtopup.ic_highload_usd_warning')}}

    --><br/>
    <payout-form-group :label="$t('Карта')" :required="model.isRequiredAttribute('cardId')"
                       :has-errors="model.errors.has('cardId')">
      <dropdown-keyvalue :options="cardOptions" :placeholder="$t('Выберите карту')"
                         :value="model.values.cardId"
                         @input="model.values.cardId = $event"></dropdown-keyvalue>
      <payout-input-hint-block v-slot:hints
                               :hint="model.getHint('cardId')"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="cardId|*"
                           :errors="model.errors"></error-message-block>
    </payout-form-group>
    <payout-textfield-input-group v-if="isTaxcodeRequired" :label="$t('Tax ID или National ID')"
                                  :model="model" attribute="taxCode"></payout-textfield-input-group>
    <payout-input-amount-form-group :model="model"></payout-input-amount-form-group>
    <payout-estimated-destination-amount-form-group
      :model="model"></payout-estimated-destination-amount-form-group>
    <payout-destination-currency-conversion-notice-form-group style="margin-top: 1em;"
                                                              :model="model"></payout-destination-currency-conversion-notice-form-group>
    <template>
      <payout-card-top-up-evaluate-fee-form-group
        :model="model"></payout-card-top-up-evaluate-fee-form-group>
    </template>
    <!--template(v-if='false')payout-form-evaluate-tax-group(:model='model')
    -->
    <payout-form-notification-block :model="model"></payout-form-notification-block>
    <hr/>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import {Component} from "vue-property-decorator";
import {
  CapitalistCardsTopupModel
} from "@/components/forms/payout/forms/capitalist/capitalist-cards-topup";
import {ModelEvents} from 'capitalist-shared/src/core/model';
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutHintPanel from "@/components/forms/payout/PayoutHintPanel.vue";
import WalletoKycResetWarningPayoutHint
  from "@/views/pages/global/notices/WalletoKycResetWarningPayoutHint.vue";
import DropdownKeyvalue from "@/components/forms/dropdown/DropdownKeyValue.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import PayoutCardTopUpEvaluateFeeFormGroup
  from "@/components/forms/payout/fee/PayoutCardTopUpEvaluateFeeFormGroup.vue";
import {IntercashServices, WalletoServices} from "@/core/capitalistcards/capitalist-cards-core";
import {CurrencyCode} from "@/models/core/currency";
import PayoutDestinationCurrencyConversionNoticeFormGroup
  from "@/components/forms/payout/crypto/PayoutDestinationCurrencyConversionNoticeFormGroup.vue";



@Component({
  name: "CapitalistCardTopupPaymentForm",
  components: {
    PayoutDestinationCurrencyConversionNoticeFormGroup,
    PayoutCardTopUpEvaluateFeeFormGroup,
    PayoutGroupVerificationType,
    PayoutFormNotificationBlock,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutInputAmountFormGroup,
    PayoutTextfieldInputGroup,
    ErrorMessageBlock,
    PayoutInputHintBlock,
    DropdownKeyvalue, WalletoKycResetWarningPayoutHint, PayoutHintPanel, PayoutFormGroup
  }
})
export default class CapitalistCardTopupPaymentForm extends AbstractPayoutForm {
  model = new CapitalistCardsTopupModel();

  mounted() {
    this.$on(ModelEvents.modelLoaded, this.onCardModelLoaded)
  }

  onCardModelLoaded() {
    this.model.preselectCard(this.queryCardId);
  }

  get isTaxcodeRequired(): boolean {
    return this.model.options.taxcode_required && this.isSelectedCardRequiredTaxCode;
  }

  get isSelectedCardRequiredTaxCode(): boolean {
    if (!this.selectedCard)
      return false;

    return [WalletoServices.Virtual,
      WalletoServices.Plastic].indexOf(this.selectedCard.tariff) >= 0;
  }

  get isSelectedCardIsWalleto(): boolean {
    if (!this.selectedCard)
      return false;

    return [WalletoServices.Virtual,
      WalletoServices.Plastic].indexOf(this.selectedCard.tariff) >= 0;
  }

  get isIntercashEuroUSDTopupNotAvailableAlert(): boolean {
    if (!this.selectedCard)
      return false;

    if (([IntercashServices.Euro_USD_250, IntercashServices.Euro_USD_20k]
        .indexOf(this.selectedCard.tariff) >= 0)
      && (this.selectedCard.currency == CurrencyCode.USD)
    ) {
      return !this.selectedCard.isTopupAvailable;
    }

    return false;
  }

  get isUSD(): boolean {
    return this.selectedCard && (this.selectedCard.currency == CurrencyCode.USD);
  }

  get hasWalleto() {
    return this.model.options.has_walleto;
  }

  get selectedCard() {
    if (!this.model.loaded) return null;
    for (const i in this.model.options.card.list) {
      const card = this.model.options.card.list[i];
      if (card.cardId == this.model.values.cardId) {
        return card;
      }
    }
    return null;
  }

  get queryCardId() {
    return this.getQueryParam('cardid');
  }

  get isSelectedCardIsVirtualWalleto() {
    if (!this.model.loaded) return false;
    for (const i in this.model.options.card.list) {
      const card = this.model.options.card.list[i];
      if (card.cardId == this.model.values.cardId) {
        return card.tariff == 'IssueWV';
      }
    }
    return false;
  }

  get cardOptions(): any {
    if (!this.model.loaded)
      return {};

    let options: any = {};

    for (const i in this.model.options.card.list) {
      const card = this.model.options.card.list[i];

      options[card.cardId] = card.cardname + ' / ' + card.pan;
    }

    return options;
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Карта": "Card",
    "Выберите карту": "Select card",
    "Tax ID или National ID": "Tax ID or National ID",
    "cardtopup": {
      "walleto_limits_warning": "If the monthly limit for online transactions and cash withdrawals from Capitalist VISA cards issued by a Lithuanian bank is exceeded, the issuer has the right to request confirmation of the origin of the funds.",
      "ic_highload_usd_warning": "Due to the sharply increased load on services, the function of replenishing the balance of virtual cards is temporarily unavailable.",
      "walleto_temp_problems": "Replenishment of plastic cards is temporarily unavailable due to changes in the issuer's regulations, the terms are being specified."
    },
    "ic_euro_usd_disabled_text": "EU cards in US dollars are not available for top-up."
  },
  "ru": {
    "ic_euro_usd_disabled_text": "Карты ЕС в долларах США недоступны для пополнения.",
    "cardtopup": {
      "walleto_temp_problems": "Пополнение пластиковых карт временно недоступно в связи с изменениями регламента эмитента, сроки уточняются.",
      "walleto_limits_warning": "В случае превышения месячного лимита по онлайн-операциям и снятию наличных с карт Capitalist VISA, выпущенных литовским банком, эмитент в праве запросить подтверждение происхождения средств.",
      "ic_highload_usd_warning": "В связи с резко возросшими нагрузками на сервисы временно недоступна функция  пополнения баланса виртуальных карт."
    }
  }
}
</i18n>
